export const getErrorMessage = (error: any) => {
    const errorMessage =
        error?.response?.data?.message || error?.response?.message || error?.message || error;
    return errorMessage;
};
